/**
 * Quest skin derived from the schedule selection.
 * No GPS: the selected item is active, or the first item of the selected day.
 * Items before that are visited. Everything else is still ahead.
 */

export type VisitState = "visited" | "active" | "upcoming";

export function itemVisitStates(
  orderedIds: readonly string[],
  selectedItemId: string | null | undefined,
): { activeId: string | null; byId: Map<string, VisitState> } {
  const activeId =
    selectedItemId && orderedIds.includes(selectedItemId)
      ? selectedItemId
      : (orderedIds[0] ?? null);
  const activeIndex = activeId == null ? -1 : orderedIds.indexOf(activeId);
  const byId = new Map<string, VisitState>();
  orderedIds.forEach((id, index) => {
    if (index === activeIndex) byId.set(id, "active");
    else if (activeIndex >= 0 && index < activeIndex) byId.set(id, "visited");
    else byId.set(id, "upcoming");
  });
  return { activeId, byId };
}
